import { render, staticRenderFns } from "./ClubPointsHistoryModal.vue?vue&type=template&id=112cd6bb&scoped=true&"
import script from "./ClubPointsHistoryModal.vue?vue&type=script&lang=js&"
export * from "./ClubPointsHistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./ClubPointsHistoryModal.vue?vue&type=style&index=0&id=112cd6bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112cd6bb",
  null
  
)

export default component.exports